import { register, getPrefix } from '../../../Utils'

const CorporateHeader = el => {
  const prefix = getPrefix(el)
  let scrollPos = 0
  const mobileSearchToggler = el.querySelector(`.${prefix}mobile-search-toggler`)
  const mobileSearch = el.querySelector(`.${prefix}mobile-search`)

  const windowScroll = () => {
    el.classList.toggle(`${prefix}is--hidden`, window.pageYOffset > 50 && window.pageYOffset > scrollPos)
    el.classList.toggle(`${prefix}is--scrolled`, window.pageYOffset > 50)
    scrollPos = window.pageYOffset
  }

  window.addEventListener('scroll', windowScroll)

  if (mobileSearchToggler) {
    mobileSearchToggler.addEventListener('click', () => mobileSearch.classList.toggle(`${prefix}is--visible`))
  }
}

register('CorporateHeader', CorporateHeader)
